import React from 'react';

//PACKS
import { connect } from 'react-redux';
import { Button, Alert, Navbar, Spinner } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { Form as FinalForm } from 'react-final-form';
import { UserPin } from '@styled-icons/boxicons-regular/UserPin';

//Containers
//import EsqueciSenha from './EsqueciSenha';

//Components
import FormInscricao from '../../../components/forms/inscricao/FormInscricao';

//ACTIONS
import { pesquisa as pesquisatraducoes } from '../../../actions/traducoes/traducoes';
import { validaacesso, inicialogin } from '../../../actions/login/login';
import { pesquisa as pesquisacargos } from '../../../actions/credenciamento/cargo';

//TOOLS
import { getTraducaoTrocaPor as trad } from '../../../utils/getTraducoes';

//UTILS
import { setUser } from '../../../utils/authusuario';

class Inscricao extends React.Component {
  state = {
    styles: {}
  }

  async componentDidMount() {

    const dados_basico_evento = {
      idevento: this.props.idevento,
      idpromotora: this.props.idpromotora
    }

    await this.props.pesquisacargos(dados_basico_evento);

    await this.props.pesquisatraducoes(
      {
        ...dados_basico_evento,
        wherein: JSON.stringify({
          campo: 'identificador',
          valores: ['conf_index']
        })
      }
    );
    this.props.inicialogin();
  }

  onSubmit = async (form) => {
    const forms = {
      idevento: this.props.idevento,
      idpromotora: this.props.idpromotora,
      ...form
    }
    const dados = await this.props.validaacesso(forms)
    setUser(dados);
  }

  render() {

    const dados_basico = {
      idevento: this.props.idevento,
      idpromotora: this.props.idpromotora,
      lingua: this.props.lingua
    }

    return (
      <FinalForm
        onSubmit={this.onSubmit}
        validate={values => {
          const errors = {};
          if (!values.email) {
            errors.email = trad(this.props.trads, 'ERROEMAIL1', dados_basico.lingua);
          }

          if (!values.senha) {
            errors.senha = trad(this.props.trads, 'ERROSENHA', dados_basico.lingua);
          }

          return errors;
        }}
        render={({ form, pristine, submitting, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Navbar bg="light" expand="lg" className="justify-content-center">
              <Navbar.Brand>{trad(this.props.trads, 'CONF_INFOPARTICIPANTES', dados_basico.lingua)}</Navbar.Brand>
              <UserPin size="60" />
            </Navbar>

            <FormInscricao {...this.props} form={form} lingua={this.props.lingua} styles={this.state.styles} />

            <Button
              id="btosubmit"
              variant="primary"
              size="lg"
              block
              type="submit"
              onClick={this.handleSubmitLog}
              disabled={submitting || pristine}
            >
              {this.props.pendingTasks ?
                <Spinner animation="border" />
                :
                trad(this.props.trads, 'BT_AVANCAR2', dados_basico.lingua)
              }
            </Button>
          </form>
        )}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    trads: state.reducerTraducoes,
    pendingTasks: state.pendingTasks,
    dadoscargos: state.pesquisaCargosReducer,
    loginResult: state.loginValidaReducer
  }
}

export default connect(mapStateToProps, {
  pesquisatraducoes,
  validaacesso,
  pesquisacargos,
  inicialogin
})(withRouter(Inscricao));